import { AgxBodyText, AgxRow } from '@urbanx/agx-ui-components';
import { formatNumber } from 'utils/formatNumber';
import EntityImage from '../../EntityImage/EntityImage';
import clsx from 'clsx';
import { CommissionRanking } from '@urbanx/agx.rex.client';

interface LeaderboardRowProps {
  leaderboardPosition: CommissionRanking;
  addRingToImage: boolean;
}

const LeaderboardRow = ({ leaderboardPosition, addRingToImage }: LeaderboardRowProps) => {
  const {
    commission: salesForTimePeriod,
    rank,
    name,
    photoUri,
    backgroundColour,
    backgroundTextColour,
    isPersonalEntity,
  } = leaderboardPosition;

  const classes = clsx('leaderboard-row', isPersonalEntity && 'highlighted');

  return (
    <AgxRow fill centered mediumGap extraClasses={classes}>
      <AgxBodyText small extraClasses="leaderboard-rowText rank">
        {rank}
      </AgxBodyText>
      <AgxRow centered fill extraClasses="image-agent">
        <EntityImage
          photoUri={photoUri ?? null}
          backgroundColour={backgroundColour ?? null}
          backgroundTextColour={backgroundTextColour ?? null}
          name={name}
          addRingToImage={addRingToImage}
        />
        <AgxBodyText small extraClasses="leaderboard-rowText name">
          {name}
        </AgxBodyText>
      </AgxRow>
      <AgxBodyText small extraClasses="leaderboard-rowText sales">
        ${formatNumber(salesForTimePeriod?.toString() ?? '')}
      </AgxBodyText>
    </AgxRow>
  );
};

export default LeaderboardRow;
